import { useContext, useState } from 'react'
import UserContext from '../state/UserContext'
import { Navigate, useParams } from 'react-router-dom'
import AppContext from '../state/AppContext'
import Unauthorized from '../pages/401/Unauthorized'

export default function GrantContent(props) {

    const { roles, permisos, isPage, children } = props
    const { user } = useContext(UserContext)
    const userRoles = user?.roles || []
    const userPermisos = user?.permissions || []
    const { appContext, setAppContext } = useContext(AppContext)
    const project = appContext.project
    const [showDebug, setShowDebug] = useState(false)

    const canAccess = () => {

        if (user.master === true) return true
        if (userRoles.find(r => r.role === "ADMIN")) return true
        if (userRoles.find(r => r.project === project && r.role === "PROJECT_ADMIN")) return true

        if (permisos) {
            for (let i = 0; i < permisos.length; i++) {
                if (userPermisos.find(p => ((p.project === null || p.project === project) && p.permission === permisos[i]))) return true
            }
        }

        if (roles) {
            for (let i = 0; i < roles.length; i++) {
                if (userRoles.includes(roles[i])) return true
            }
        }

        return false
    }

    const showDebugInformation = () => {
        if (process.env.REACT_APP_ENVIRONMENT === "production") return false;
        if (showDebug) return true;
        return false;
    }

    if (!user) {
        return null
    }

    if (canAccess()) {
        return typeof children === 'function' ? children(true, roles, permisos, isPage) : children
    } else if (showDebugInformation()) {
        return (<small className="text-red-500 text-[8px]"><rem>Need {permisos.join(", ")} permissions</rem></small>)
    } else if (isPage) {
        return <Unauthorized roles={roles} permisos={permisos} />
    } else if (typeof children === 'function') {
        return children(false, roles, permisos, isPage)
    } else {
        return null
    }
}